import { documentToHtmlString } from '@contentful/rich-text-html-renderer';
import { Document } from '@contentful/rich-text-types';

import { checkFeatureFlagGate } from '@/utils/feature-flags/check-feature-flag';
import { featureFlags } from '@/utils/feature-flags/feature-flag-manifest';

export const richTextToHTML = (richText: Document) => {
	let htmlString: string = documentToHtmlString(richText);

	htmlString = htmlString.replace(/\n/g, '<br />');

	return htmlString;
};

const DEFAULT_STRIP_KEYS = new Set(['sys', 'metadata', 'createdAt', 'updatedAt']);

export interface StripContentfulMetadataOptions {
	keys?: Set<string> | string[];
}
export const stripContentfulMetadata = (
	data: unknown,
	options: StripContentfulMetadataOptions = {},
): void => {
	const keysToStrip =
		options.keys !== null && options.keys !== undefined
			? new Set(options.keys)
			: DEFAULT_STRIP_KEYS;

	const walk = (node: unknown): void => {
		if (Array.isArray(node)) {
			node.forEach(walk);
		} else if (node !== null && typeof node === 'object') {
			const obj = node as Record<string, unknown>;
			for (const key of keysToStrip) {
				delete obj[key];
			}
			for (const value of Object.values(obj)) {
				walk(value);
			}
		}
	};

	walk(data);
};

export const getShouldStripExcessData = () => {
	return checkFeatureFlagGate(featureFlags.waePricingStripExcessData);
};
